import React from 'react';
import {KeenIcon} from '@/components';
import {toAbsoluteUrl} from '@/utils';
import {Link} from "react-router-dom";

interface NoJobsContentProps {
    onAddNewJob?: () => void
}

const NoJobsContent: React.FC<NoJobsContentProps> = ({onAddNewJob}) => {
    return (
        <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
            <div className="lg:col-span-3">
                <div className="mb-7.5">
                    <div className="card">
                        <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
                            <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                                <div className="flex flex-col gap-3">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        Start by adding your first job!
                                    </h1>
                                    <h2 className="text-1xl font-semibold text-gray-900">
                                        Create a job listing to unlock the power of smart hiring.
                                    </h2>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        To begin, add a job posting – the first step towards managing your hiring
                                        pipeline.
                                        Once your job is created, you'll be able to sort through candidates, match the
                                        right talent to this role, and
                                        streamline your recruitment process.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Adding a job is quick and easy: fill in details from a URL, drag and drop your
                                        job description file, or simply
                                        copy and paste the necessary information. After that, you’ll be ready to attract
                                        and evaluate candidates
                                        with confidence and efficiency.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Don’t worry – UPFLINX Buddy makes everything simple and intuitive, even if
                                        you’re new to AI-driven hiring
                                        tools.
                                    </p>
                                </div>
                                <img
                                    src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                    className="dark:hidden max-h-[250px]"
                                    alt="Welcome"
                                />
                            </div>
                        </div>
                        <div className="card-footer justify-center">
                            <a onClick={onAddNewJob} className="btn btn-link" role="button">
                                Add your first job now!
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {NoJobsContent};
